var EdgeLengthComparator = require('./EdgeLengthComparator');
	
	var SubdivisionStrategy, proto;
	SubdivisionStrategy = function(){
		this._order = SubdivisionStrategy.DEFAULT_ORDERING;
	};
	SubdivisionStrategy.DEFAULT_ORDERING = new EdgeLengthComparator();
	proto = SubdivisionStrategy.prototype;

	proto.getEdgeOrdering = function(){
		return this._order.compare;
	};
	proto.setEdgeOrdering = function( order ){
		this._order = order;
	};

	module.exports = SubdivisionStrategy;




//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/geom/mesh/subdiv/SubdivisionStrategy.js
// module id = 4588
// module chunks = 14